import { VFC, ReactNode } from 'react';
import classNames from 'classnames';
import { useTextOverflow } from '../common/useTextOverflow';
import { DEFAULT_POSTER_ID } from '../PosterList';
import hostIcon from '../../../imgs/share-poster-host.png';
import './index.scss';

const SP_POSTER_IDS = [9, 10, 11];
const PosterHost: VFC<{
  host: string;
  line?: number;
  extra?: ReactNode | string;
  className?: string;
  posterId: number;
}> = ({ host, line, extra = '主办', className, posterId }) => {
  const { containerRef, textsRef, textDoms } = useTextOverflow(host, posterId);
  const isSpId = SP_POSTER_IDS.includes(posterId);
  const isDefaultPoster = posterId === DEFAULT_POSTER_ID;
  return (
    <div
      className={classNames('poster-host', `line-${line}`, className)}
      ref={Number(line) > 1 && !isSpId ? containerRef : null}
    >
      <div className="poster-host-text" ref={Number(line) === 1 || isSpId ? containerRef : null}>
        {isDefaultPoster && (
          <img className="poster-host-icon" crossOrigin="anonymous" src={hostIcon} />
        )}
        <span className="poster-host-text-value" ref={textsRef}>
          {textDoms}
        </span>
      </div>
      {extra && <div className="poster-host-extra">{extra}</div>}
    </div>
  );
};

export default PosterHost;
